export const TERMS_OF_USE = 'https://medicalhomenetwork.org/mhnconnect-terms-of-use';
export const PRIVACY_POLICY = 'https://medicalhomenetwork.org/mhnconnect-privacy-policy';
export const COMPLIANCE = 'https://medicalhomenetwork.org/compliance';
